import { render } from "./CourseTrack.vue?vue&type=template&id=65c3e86e&scoped=true&ts=true"
import script from "./CourseTrack.vue?vue&type=script&lang=ts"
export * from "./CourseTrack.vue?vue&type=script&lang=ts"

import "./CourseTrack.vue?vue&type=style&index=0&id=65c3e86e&lang=css"
import "./CourseTrack.vue?vue&type=style&index=1&id=65c3e86e&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c3e86e"]])

export default __exports__